import React from "react";

const MailBox = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="23"
      viewBox="0 0 32 23"
      fill="none"
    >
      <path
        d="M18.5135 15.1324C17.7652 15.6313 16.896 15.895 15.9999 15.895C15.1037 15.895 14.2345 15.6313 13.4862 15.1324L1.1612 6.91549C1.09282 6.8699 1.0262 6.82237 0.960938 6.7735V20.2379C0.960938 21.7816 2.21369 23.0067 3.7298 23.0067H28.2699C29.8136 23.0067 31.0387 21.754 31.0387 20.2379V6.77344C30.9733 6.82243 30.9066 6.87008 30.838 6.91572L18.5135 15.1324Z"
        fill="white"
      />
      <path
        d="M2.13879 5.44599L14.4638 13.663C14.9304 13.9741 15.4651 14.1296 15.9998 14.1296C16.5346 14.1296 17.0693 13.974 17.5359 13.663L29.8609 5.44599C30.5985 4.95458 31.0388 4.13214 31.0388 3.24449C31.0388 1.71821 29.7971 0.476562 28.2709 0.476562H3.72886C2.20265 0.476621 0.960938 1.71827 0.960938 3.24596C0.960938 4.13214 1.4013 4.95458 2.13879 5.44599Z"
        fill="white"
      />
    </svg>
  );
};

export default MailBox;
